export class BasketErrorModel extends Error {
    public innerError: BasketErrorModel | Error | null;
    public logMessage: string | null;
    public source: string | null;
    public data: { key: string; value: any }[] | null;

    constructor(userFriendlyMessage: string, logMessage?: string, source?: string, additionalData?: { key: string; value: any }[], innerError?: BasketErrorModel) {
        super(userFriendlyMessage);

        this.innerError = innerError ?? null;
        this.logMessage = logMessage ?? userFriendlyMessage;
        this.source = source ?? null;
        this.data = additionalData ?? null;
    }
}

export const DEFAULT_ERROR_TEXT = 'Sorry, something went wrong, please try again later';